module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"actions":"@:labels.actions","archive":"@:labels.archive","delete":"@:labels.delete","new":"New State","properties":"@:labels.properties"},"fr":{"actions":"@:labels.actions","archive":"@:labels.archive","delete":"@:labels.delete","new":"Nouvel état","properties":"@:labels.properties"}}')
  delete Component.options._Ctor
}
